import React, { useState, createRef, useEffect, useCallback } from "react";
import { Grid, Sticky, Message } from "semantic-ui-react";
import { useLocation } from "@reach/router";
import { SubstrateContextProvider, useSubstrate } from "./substrate-lib";
import { DeveloperConsole } from "./substrate-lib/components";
import {
  Col,
  Row,
  Spin,
  Card,
  Modal,
  Button,
  Icon,
  InputNumber,
  message,
  Collapse,
} from "antd";
import "antd/dist/antd.css";
import { bridgeConfig } from "./config/bridgeConnection";
import { ToastProvider, useToasts } from "react-toast-notifications";
import { Web3Provider } from "@ethersproject/providers";
import SubstrateAdaptor from "./adaptors/SubstrateAdaptor";
import { parse } from "query-string";
import { TransferAdaptor } from "./adaptors/TransferAdaptor";
import { ArrowDownOutlined, LoadingOutlined } from "@ant-design/icons";
import bannerImg from "./assets/images/crowdloan-banner.png";
import BCDarkLogo from "./assets/images/BCMN-logo-dark-gb.png";
import KSMAnimation from "./AnimationScene";
import Logging from "./utils/Logging";

const { Panel } = Collapse;

const faqs = [
  {
    question: "Who can be whitelisted for the Metaverse Odyssey Event?",
    answer:
      "If you contributed to Metaverse Network - Bit.Country Pioneer's Crowdloan, directly on Polkadot Apps, via our Crowdloan page, PolkaWallet, Fearless Wallet, or other parachain PLO partners, except for contributions through exchanges. You can check your eligibility using the form above." +
      "<br/>" +
      "<br/>" +
      "For qualified ambassadors, node operators, star program members, and other selected groups. Your email address will be whitelisted if you meet our criteria. You will receive an email from noreply@bit.country or hi@bit.country, please make sure you add these two email addresses as contacts in your email client. Or check your spam folder.",
  },
  {
    question:
      "Why do I need to be whitelisted for the Metaverse Odyssey Event?",
    answer:
      "The Metaverse Odyssey event is made of rounds where users must be whitelisted for registration to ensure that as many valued contributors can get an allocation. If you aren't whitelisted in time to complete registration and KYC before the announced cut-off date of the event, you won't be able to register and participate.",
  },
  {
    question: "What is KYC?",
    answer:
      "It is the process whereby users of a specific digital platform, event or network are asked to identify themselves as authentic and genuine persons. This is done by providing the necessary documents to verify and prove their identity.",
  },
  {
    question: "Where do I submit my KYC documents?",
    answer:
      "Our KYC is handled by Tokensoft, a third party service provider. The process is completely digital, and is a part of the registration process. During the process, you will be asked to take photos of your relevant identity documents, along with a selfie.",
  },
  {
    question: "Will getting whitelisted guarantee me some allocation?",
    answer:
      "No, not by itself. You will be invited to register for the Metaverse Odyssey Event before it starts. Only participants who meet the criteria of the platform and successfully completed KYC before the announced cut-off date will be able to proceed further.",
  },
  {
    question: "How do I know if I qualify for participation?",
    answer:
      "Qualification is determined soon after you have completed the registration process (not pre-whitelisting process) handled by our third party service provider Tokensoft. " +
      "After registration, you should receive an email confirming whether you are successfully qualified for the event (please remember to check your spam folder). " +
      "If you didn't qualify, you will also receive an email confirming this.",
  },
  {
    question:
      "Which countries are allowed to participate in the Metaverse Odyssey Event?",
    answer:
      "We aim to allow participants to join from most countries for the Metaverse Odyssey Event, however our third party service provider, Tokensoft, aren't able to KYC participants from the following jurisdictions: United States, New Zealand, China, Iran, Cuba, Syria and North Korea.",
  },
];

function Main(props) {
  const { api, keyring, keyringState, apiState } = useSubstrate();
  const [accountAddress, setAccountAddress] = useState(null);
  const [accountName, setAccountName] = useState(null);
  const accountPair = accountAddress && keyring.getPair(accountAddress);
  const contextRef = createRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [tradingPath, setTradingPath] = useState([0, 1]);
  const [referralCode, setReferralCode] = useState("");
  const [apiLoading, setApiLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  const [fadeOutForm, setFadeOutForm] = useState(true);

  const [accountBalance, setAccountBalance] = useState(0);

  const [isSignatureValid, setIsSignatureValid] = useState(false);
  const [step, setStep] = useState(1);

  const loadingIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />;

  const showMessage = (err) => {
    message.info(err);
  };

  useEffect(() => {
    if (apiState === "ERROR") {
      showMessage("Error while connecting to blockchain");
    }

    if (keyringState !== "READY" || apiState !== "READY") {
      setApiLoading(true);
    } else if (keyringState === "READY" && apiState === "READY") {
      setApiLoading(false);
    }
  }, [apiState, keyringState]);

  useEffect(() => {
    const searchParam = parse(location.search);
    if (
      searchParam["referralCode"] != null &&
      searchParam["referralCode"] != ""
    ) {
      setReferralCode(searchParam["referralCode"]);
    }
  }, []);

  const playAnimation = () => {
    // setFadeOutForm(true);
    // window?.excited?.start();
    // const ele = document.getElementById("canary-canvas");
    // ele.classList += `canary-fade-in-opacity`;
    // ele.style.opacity = 1;

    setTimeout(() => {
      setFadeOutForm(false);
      // ele.style.opacity = 0.3;
    }, 500);
  };

  useEffect(() => {
    playAnimation();
  }, []);

  const renderFAQ = () => {
    return (
      <div className="faq-section">
        {faqs.map((res, index) => (
          <div>
            <div className="question-section">{res.question}</div>
            <div
              dangerouslySetInnerHTML={{ __html: res.answer }}
              className="answer-faq"
            ></div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <ToastProvider autoDismiss>
      {!fadeOutForm ? (
        <div className={`${fadeOutForm ? "fade-out" : "fade-in"}`}>
          <div className="title-header">
            <h2>Pre-whitelisting for the Metaverse Odyssey Event</h2>
          </div>
          <div
            style={{
              margin: "0 auto",
              width: "595px",
              textAlign: "center",
            }}
          >
            {/* <div
              style={{
                color: "orange",
                fontSize: "20px",
                marginBottom: 10,
                textAlign: "left",
              }}
            >
              <b>Key dates:</b>
              <br />
              <ul>
                <li style={{ listStyle: "none" }}>
                  <b>Round 1: Private Sale (Guaranteed)</b>
                </li>
                <li style={{ listStyle: "none", paddingLeft: "2em" }}>
                  Start time: November 30th at 15:00 UTC
                </li>
                <li style={{ listStyle: "none", paddingLeft: "2em" }}>
                  End time: December 2rd at 15:00 UTC
                </li>
              </ul>
              <ul>
                <li style={{ listStyle: "none" }}>
                  <b>Round 2: Private Sale (First Come First Serve)</b>
                </li>
                <li style={{ listStyle: "none", paddingLeft: "2em" }}>
                  Start time: December 2rd at 15:00 UTC
                </li>
                <li style={{ listStyle: "none", paddingLeft: "2em" }}>
                  End time: December 4th at 15:00 UTC or until sold out
                </li>
              </ul>
              <ul>
                <li style={{ listStyle: "none" }}>
                  <b>Round 3: Public Sale (First Come First Serve)</b>
                </li>
                <li style={{ listStyle: "none", paddingLeft: "2em" }}>
                  Start time: TBC unless sold out
                </li>
                <li style={{ listStyle: "none", paddingLeft: "2em" }}>
                  End time: TBC unless sold out
                </li>
              </ul>
            </div> */}
          </div>
          <Col span={22} className="crowdloan-container">
            <Col span={24} className={`crowdloan-body`}>
              <h3 className="title-header">
                Pre-whitelisting for Bit.Country Pioneer Crowdloan Contributors
                has closed.
              </h3>
              <div
                style={{
                  color: "orangered",
                  fontSize: "20px",
                  marginBottom: 40,
                }}
              >
                Please complete your KYC on Tokensoft as soon as possible. The
                Tokensoft KYC team will prioritize the Pre-whitelisted email to
                complete all KYC reviews 12 hours before the sale start.
              </div>
            </Col>
          </Col>
          <Col span={24} className="faq-wrapper" id="faq">
            <div className="title-header">
              <h2>Frequently Asked Questions</h2>
            </div>
            <Row>{renderFAQ()}</Row>
          </Col>
        </div>
      ) : null}
      <Modal
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={() => setIsModalOpen(false)}
        footer={[
          <Button key="back" onClick={() => setIsModalOpen(false)}>
            Close
          </Button>,
        ]}
      ></Modal>
    </ToastProvider>
  );
}

export default function Home(props) {
  return <Main {...props} />;
}
